import { useSelector } from 'react-redux';
import { trackEvent } from 'fathom-client';
import { getRequestHeaders } from 'lib/helpers';

import { selectCurrentUser } from 'features/auth/slice';

import useChargebee from 'lib/hooks/useChargebee';
import useSubscription from 'lib/hooks/useSubscription';

import { flash } from '@frontendmentorio/design-system-v2';
import AuthButton from 'features/shared/AuthButton';

export default function PurchaseButton({ plan, ...props }) {
  const currentUser = useSelector(selectCurrentUser);
  const instance = useChargebee();
  const { pollForSubscription } = useSubscription();

  const handleClick = () => {
    trackEvent('Checkout start');

    const headers = getRequestHeaders();

    instance.openCheckout({
      hostedPage: async () => {
        const res = await fetch('/api/portal/checkout', {
          body: JSON.stringify({
            planId: plan.id,
            referralCode: window.tolt_referral,
          }),
          headers: { 'Content-Type': 'application/json', ...headers },
          method: 'POST',
        });

        const body = await res.json();

        if (!res.ok) return flash.error(body.message);

        return body;
      },
      success: () => {
        instance.closeAll();
        trackEvent('Checkout success');
        pollForSubscription();
      },
    });
  };

  if (currentUser?.hasActiveSubscription || !instance || !plan.id) return null;

  return (
    <AuthButton
      className="w-full"
      onClick={() => handleClick(plan.id)}
      redirectPath="/pro#plans"
      {...props}
    >
      Upgrade now
    </AuthButton>
  );
}
